module.exports = __webpack_public_path__ + "img/nikolai-lockertsen-walk-the-dog.0e62f21.jpg";